// @flow weak

import _ from 'lodash/fp';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import Button from '../Button/Button';

const navigation = (list, current) => {
  let previous, next;
  if (!!current && !!list && !!list.length) {
    const currIdx = _.findIndex(x => x.id === current.id, list);
    if (currIdx > 0) {
      previous = list[currIdx - 1];
    }
    if (currIdx < list.length - 1) {
      next = list[currIdx + 1];
    }
  }
  return {
    previous,
    next,
  };
};

export type Props = {
  history: Object,
  prevPath?: string,
  current?: ?any,
  list?: any[],
  clear?: Function,
  fetchData?: (id: ?any) => any,
  hideNavigation?: bool,
};

class Navigation extends Component<Props> {
  goTo(entity) {
    const {
      history,
      prevPath,
      clear,
      fetchData,
    } = this.props;

    if (!clear || !fetchData || !prevPath) {
      return null;
    }

    return () => {
      // eslint-disable-next-line
      history.replace(`${prevPath}/${entity.id}`);
      clear();
      fetchData(entity.id);
    };
  }

  render() {
    const {
      clear,
      current,
      fetchData,
      list,
      prevPath,
      hideNavigation = false,
    } = this.props;

    const {
      previous,
      next,
    } = navigation(list, current);

    const disabled = !clear || !fetchData || !prevPath;

    return [
      <Button
        key="back"
        icon="bars" />,
      ...(hideNavigation
        ? []
        : [
          <Button
            key="previous"
            disabled={!!disabled || !previous}
            onClick={!!previous ? this.goTo(previous) : null}
            icon="chevron-left" />,
          <Button
            key="next"
            disabled={!!disabled || !next}
            onClick={!!next ? this.goTo(next) : null}
            icon="chevron-right" />,
        ]
      ),
    ];
  }
}

const none = () => ({});
export default withRouter(connect(none, none)(Navigation));



// WEBPACK FOOTER //
// ./src/components/Navigation/Navigation.js